<mat-form-field class="flex-fill" appearance="outline" [subscriptSizing]="subscriptSizing" [floatLabel]="floatLabel === 'never' ? 'auto' : floatLabel">
  <mat-label *ngIf="floatLabel !== 'never'">{{label}}</mat-label>
  <mat-select [value]="selectedIsos" multiple (selectionChange)="onSelectionChange($event)" [disabled]="isDisabled" [placeholder]="floatLabel === 'never' ? label : ''" panelClass="country-multi-select-panel">
    <mat-select-trigger *ngIf="showAllOption">
      {{displayText}}
    </mat-select-trigger>
    <mat-option *ngIf="showAllOption" value="ALL">All countries</mat-option>
    <mat-option *ngFor="let country of countries" [value]="country.iso2">
      {{country.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
